import ToggleButton from '../../../common/ToggleButton/ToggleButton'
import { useConfirmModal } from '../../../hooks/useConfirmModal'
import { WorkspaceVcmModalConfirm } from '../../VcmModalConfirm/WorkspaceVcmModalConfirm'
import { VcmDisabledModalConfirm } from '../../VcmModalConfirm/VcmDisableModalConfirm'

interface Props {
  onChange: (isChecked: boolean) => void
  onToggle: (isChecked: boolean) => void
  isChecked: boolean
}

export const VcmToggleButton = ({ onChange, isChecked, onToggle }: Props) => {
  const confirmEnabled = useConfirmModal(WorkspaceVcmModalConfirm)
  const confirmDisabled = useConfirmModal(VcmDisabledModalConfirm)

  const confirm = (versionControlMode: boolean) => (versionControlMode ? confirmEnabled() : confirmDisabled())

  const handleChange = async (isChecked: boolean) => {
    onToggle(isChecked)
    const isConfirmed = await confirm(isChecked)

    if (!isConfirmed) {
      return onToggle(!isChecked)
    }

    return onChange(isChecked)
  }

  return (
    <ToggleButton
      name="versionControlMode"
      checked={isChecked}
      handleChange={({ target }) => handleChange(target.checked)}
    />
  )
}
